const mediaItems = [
  {
    id: 1,
    title: '独家实拍：某顶流深夜会面全程记录',
    duration: '03:28',
    views: '12.6万',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20night%20scene%20editorial%20illustration%20with%20dramatic%20lighting%2C%20abstract%20figures%20in%20urban%20setting%2C%20warm%20red%20and%20amber%20tones%2C%20modern%20digital%20art%20style%2C%20paparazzi%20photography%20aesthetic%2C%20professional%20quality%2C%20clean%20composition&width=800&height=450&seq=media-01-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '综艺节目冲突现场画面全曝光',
    duration: '05:12',
    views: '9.8万',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20TV%20studio%20set%20editorial%20illustration%20with%20conflict%20atmosphere%2C%20spotlight%20beams%20and%20abstract%20figures%2C%20warm%20red%20and%20amber%20color%20scheme%2C%20cinematic%20composition%2C%20modern%20digital%20art%2C%20professional%20quality&width=800&height=450&seq=media-02-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '爆料人匿名采访：揭开娱乐圈潜规则黑幕',
    duration: '08:45',
    views: '7.3万',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20interview%20scene%20editorial%20illustration%20with%20shadow%20figure%20and%20recording%20equipment%2C%20warm%20dramatic%20lighting%2C%20red%20and%20amber%20accents%2C%20modern%20digital%20art%20style%2C%20professional%20journalism%20aesthetic%2C%20clean%20composition&width=800&height=450&seq=media-03-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10 font-heading">
          实拍视频
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 border border-secondary-200/60 rounded-xl overflow-hidden hover:border-primary-200/60 transition-colors cursor-pointer"
            >
              <div className="relative overflow-hidden h-48">
                <img
                  src={item.image}
                  alt={`${item.title} - 五一黑料网实拍视频`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  width="800"
                  height="450"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center bg-primary-500/90 rounded-full group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-1 bg-background-950/70 text-background-50 text-xs rounded-md whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}